import React, { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Skills', href: '#skills' },
  { label: 'Projects', href: '#projects' },
    { label: 'Certifications', href: '#certifications' },
  { label: 'Contact', href: '#contact' },

];

const Header = ({ activeSection }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (e, href) => {
    e.preventDefault();
    const id = href.replace('#', '');
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-[#0a0f1e]/95 backdrop-blur-md shadow-lg shadow-cyan-500/5 border-b border-white/5' : 'bg-transparent'
    }`}>
      <nav className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <a href="#home" onClick={(e) => scrollTo(e, '#home')}
          className="font-mono text-cyan-400 text-xl font-bold tracking-wider hover:text-cyan-300 transition-colors">
          CMK<span className="text-white">.</span>
        </a>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map(({ label, href }) => {
            const id = href.replace('#', '');
            const isActive = activeSection === id;
            return (
              <li key={label}>
                <a href={href} onClick={(e) => scrollTo(e, href)}
                  className={`text-sm font-medium transition-all duration-300 relative group ${
                    isActive ? 'text-cyan-400' : 'text-slate-400 hover:text-white'
                  }`}>
                  {label}
                  <span className={`absolute -bottom-1 left-0 h-px bg-cyan-400 transition-all duration-300 ${
                    isActive ? 'w-full' : 'w-0 group-hover:w-full'
                  }`} />
                </a>
              </li>
            );
          })}
        </ul>

        {/* CTA Button */}
        <a href="#contact" onClick={(e) => scrollTo(e, '#contact')}
          className="hidden md:block px-5 py-2 text-sm font-semibold border border-cyan-500 text-cyan-400 rounded-full hover:bg-cyan-500 hover:text-navy-900 hover:text-[#0a0f1e] transition-all duration-300">
          Hire Me
        </a>

        {/* Hamburger */}
        <button onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden flex flex-col gap-1.5 p-2 z-50" aria-label="Toggle menu">
          <span className={`block w-6 h-0.5 bg-cyan-400 transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`block w-6 h-0.5 bg-cyan-400 transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-6 h-0.5 bg-cyan-400 transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </nav>

      {/* Mobile Menu */}
      <div className={`md:hidden transition-all duration-300 overflow-hidden ${menuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
        <ul className="flex flex-col gap-1 px-6 pb-6 bg-[#0d1427] border-t border-white/5">
          {navLinks.map(({ label, href }) => (
            <li key={label}>
              <a href={href} onClick={(e) => scrollTo(e, href)}
                className="block py-3 text-slate-300 hover:text-cyan-400 font-medium transition-colors border-b border-white/5">
                {label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </header>
  );
};

export default Header;
